import { APPOINTMENT_TASK_EVENTS_FILTER_URL, VAULTS_API_URL, VAULTS_FILTER_URL, VAULTS_URL } from 'constants/ApiConstants';
import { INACTIVE, ACTIVE } from 'constants/LockerConstants';

import * as actionTypes from './actionTypes';

export const reactivateLocker = id => ({
  type: actionTypes.REACTIVATE_LOCKER_REQUEST,
  payload: {
    request: {
      method: 'PATCH',
      url: `${VAULTS_API_URL}/${id}/status`,
      data: { status: ACTIVE },
    },
  },
});

export const reactivateLockerSuccess = locker => ({
  type: actionTypes.REACTIVATE_LOCKER_SUCCESS,
  payload: locker,
});

export const reactivateLockerFailure = error => ({
  type: actionTypes.REACTIVATE_LOCKER_FAILURE,
  payload: {
    message: error,
  },
  error: true,
});

export const fetchVaultsSuccess = payload => ({
  type: actionTypes.FETCH_VAULTS_SUCCESS,
  payload,
});

/** @TODO Remove useless versioning */
export const fetchVault = params => ({
  type: actionTypes.FETCH_VAULT_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${VAULTS_URL}/${params.id}?v=${Date.now()}`,
      params: {
        ...params,
        projection: 'details',
      },
    },
  },
});

/**
 * @param {string} message
 * @param {Object} [meta={}]
 * @returns {import('modules/global/generic.types').Action<string>}
 */
export const fetchVaultFailure = (message, meta = {}) => ({
  type: actionTypes.FETCH_VAULT_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const fetchVaultSuccess = payload => ({
  type: actionTypes.FETCH_VAULT_SUCCESS,
  payload,
});

export const deactivateLocker = id => ({
  type: actionTypes.DEACTIVATE_LOCKER_REQUEST,
  payload: {
    request: {
      method: 'PATCH',
      url: `${VAULTS_API_URL}/${id}/status`,
      data: { status: INACTIVE },
    },
  },
});

export const deactivateLockerSuccess = locker => ({
  type: actionTypes.DEACTIVATE_LOCKER_SUCCESS,
  payload: locker,
});

export const deactivateLockerFailure = error => ({
  type: actionTypes.DEACTIVATE_LOCKER_FAILURE,
  payload: {
    message: error,
  },
  error: true,
});

export const fetchAppointmentTasksEvents = (id, params) => ({
  type: actionTypes.FETCH_APPOINTMENT_TASKS_EVENTS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: APPOINTMENT_TASK_EVENTS_FILTER_URL,
      params: {
        vaultId: id,
        ...params,
      },
    },
  },
  meta: {
    id,
  },
});

export const fetchAppointmentTasksEventsSuccess = (events, meta) => ({
  type: actionTypes.FETCH_APPOINTMENT_TASKS_EVENTS_SUCCESS,
  payload: events,
  meta,
});

export const fetchAppointmentTasksEventsFailure = error => ({
  type: actionTypes.FETCH_APPOINTMENT_TASKS_EVENTS_FAILURE,
  payload: {
    message: error,
  },
  error: true,
});

export const openLockerPrepareConfirmModal = () => ({
  type: actionTypes.OPEN_LOCKER_PREPARE_CONFIRM_MODAL,
});

export const closeLockerPrepareConfirmModal = () => ({
  type: actionTypes.CLOSE_LOCKER_PREPARE_CONFIRM_MODAL,
});

export const openLockerVerifyConfirmModal = () => ({
  type: actionTypes.OPEN_LOCKER_VERIFY_CONFIRM_MODAL,
});

export const closeLockerVerifyConfirmModal = () => ({
  type: actionTypes.CLOSE_LOCKER_VERIFY_CONFIRM_MODAL,
});

export const openLockerUnprepareConfirmModal = () => ({
  type: actionTypes.OPEN_LOCKER_UNPREPARE_CONFIRM_MODAL,
});

export const closeLockerUnprepareConfirmModal = () => ({
  type: actionTypes.CLOSE_LOCKER_UNPREPARE_CONFIRM_MODAL,
});

export const generateRandomCode = vaultId => ({
  type: actionTypes.FETCH_GENERATE_CODE_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${VAULTS_API_URL}/${vaultId}/code/generate`,
    },
    id: vaultId,
  },
});

export const generateRadomCodeSuccess = (code, meta = {}) => ({
  type: actionTypes.FETCH_GENERATE_CODE_SUCCESS,
  payload: code,
  meta,
});

export const generateRandomCodeFailure = (message, meta = {}) => ({
  type: actionTypes.FETCH_GENERATE_CODE_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const flushGeneratedError = () => ({
  type: actionTypes.FLUSH_GENERATE_CODE_ERROR,
});

export const validateLockerCode = (code, vaultId, meta = {}) => ({
  type: actionTypes.FETCH_VALIDATE_CODE_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${VAULTS_API_URL}/${vaultId}/code/validate`,
      data: { code },
    },
    vaultId,
    code,
  },
  meta,
});

export const validateLockerCodeSuccess = (isValid, meta = {}) => ({
  type: actionTypes.FETCH_VALIDATE_CODE_SUCCESS,
  payload: isValid,
  meta,
});

export const validateLockerCodeFailure = ({ code, vaultId, message }, meta = {}) => ({
  type: actionTypes.FETCH_VALIDATE_CODE_FAILURE,
  payload: {
    code,
    vaultId,
    message,
  },
  error: true,
  meta,
});

export const patchLockerCode = (vaultId, code, meta = {}) => ({
  type: actionTypes.PATCH_CODE_REQUEST,
  payload: {
    request: {
      method: 'PATCH',
      url: `${VAULTS_API_URL}/${vaultId}/code`,
      data: {
        code,
      },
    },
    vaultId,
  },
  meta,
});

export const patchLockerCodeSuccess = (locker, meta = {}) => ({
  type: actionTypes.PATCH_CODE_SUCCESS,
  payload: locker,
  meta,
});

export const patchLockerCodeFailure = (message, meta = {}) => ({
  type: actionTypes.PATCH_CODE_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const openCodeModalUpdate = (vaultId, code) => ({
  type: actionTypes.OPEN_CODE_MODAL,
  payload: {
    vaultId,
    code,
  },
});

export const closeCodeModalUpdate = () => ({
  type: actionTypes.CLOSE_CODE_MODAL,
});

export const setUpdatingCode = code => ({
  type: actionTypes.SET_UPDATING_CODE,
  payload: code,
});

export const createLocker = (locker, meta = {}) => ({
  type: actionTypes.POST_LOCKER_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: VAULTS_API_URL,
      data: locker,
    },
  },
  meta,
});

export const createLockerSuccess = (locker, meta = {}) => ({
  type: actionTypes.POST_LOCKER_SUCCESS,
  payload: locker,
  meta,
});

export const createLockerFailure = (message, meta = {}) => ({
  type: actionTypes.POST_LOCKER_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const updateLocker = (locker, meta = {}) => ({
  type: actionTypes.PUT_LOCKER_REQUEST,
  payload: {
    request: {
      method: 'PUT',
      url: `${VAULTS_API_URL}/${locker.id}`,
      data: locker,
    },
  },
  meta,
});

export const updateLockerSuccess = (locker, meta = {}) => ({
  type: actionTypes.PUT_LOCKER_SUCCESS,
  payload: locker,
  meta,
});

export const deleteLocker = (id, meta = {}) => ({
  type: actionTypes.DELETE_LOCKER_REQUEST,
  payload: {
    request: {
      method: 'DELETE',
      url: `${VAULTS_API_URL}/${id}`,
    },
    id,
  },
  meta,
});

export const deleteLockerSuccess = (locker, meta = {}) => ({
  type: actionTypes.DELETE_LOCKER_SUCCESS,
  payload: locker,
  meta,
});

export const deleteLockerFailure = (message, meta = {}) => ({
  type: actionTypes.DELETE_LOCKER_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const refreshLockerDashboard = params => ({
  type: actionTypes.REFRESH_DASHBOARD,
  payload: params,
});

export const getLockers = (params, meta = {}) => ({
  type: actionTypes.GET_LOCKERS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: VAULTS_FILTER_URL,
      params: {
        status: [INACTIVE, ACTIVE],
        projection: 'details',
        fields: 'id,reference,status,dealer,physicalConfig',
        sort: 'reference,asc',
        ...params,
      },
    },
  },
  meta,
});

export const getLockersSuccess = (data, meta = {}) => ({
  type: actionTypes.GET_LOCKERS_SUCCESS,
  payload: data,
  meta,
});

export const getLockersFailure = (message, meta = {}) => ({
  type: actionTypes.GET_LOCKERS_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const setDashboardFilters = ({ filter, value }, meta = {}) => ({
  type: actionTypes.SET_DASHBOARD_FILTERS,
  payload: {
    [filter]: value,
  },
  meta,
});

export const openShareboxLocker = (lockerId, appointmentTaskId, appointmentId) => ({
  type: actionTypes.OPEN_SHAREBOX_LOCKER_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${VAULTS_API_URL}/${lockerId}/open`,
      data: {
        appointmentTaskId,
      },
    },
  },
  meta: {
    appointmentId,
  },
});

export const openShareboxLockerSuccess = () => ({
  type: actionTypes.OPEN_SHAREBOX_LOCKER_SUCCESS,
});

export const openShareboxLockerFailure = error => ({
  type: actionTypes.OPEN_SHAREBOX_LOCKER_FAILURE,
  payload: error,
  error: true,
});
